import React, { useEffect } from "react";
import { OutOfStockCard, Popover } from "@aph/ui-lib-humanx";

import serverCartErrorMessageSelector from "@/redux/slice/cart/selectors/serverCartErrorMessage";
import { DeviceInfo } from "@/interface/deviceInfo";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setServerCartErrorMessage } from "@/redux/slice/cart/slice";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import manageCart from "@/redux/slice/cart/container/manageCart";
import styles from "./CartManager.module.scss";
import signedInStatusSelector from "@/redux/slice/auth/selectors/signedInState";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { isBrowser } from "@/libs/helpers";
import { v4 as uuidv4 } from "uuid";
import { useApolloClient } from "@apollo/client";
import { usePathname } from "next/navigation";
import { fetchGuestCart } from "../../utils/fetchGuestCart";

interface CartManagerProps {
  ua?: DeviceInfo;
}

const CartManager: React.FC<CartManagerProps> = (props) => {
  const { ua } = props;
  const dispatch = useAppDispatch();
  const apolloClient = useApolloClient();
  const routerPathName = usePathname() as string;
  const serverCartErrorMessage = useAppSelector(serverCartErrorMessageSelector);

  const isSignedIn = useAppSelector(signedInStatusSelector);
  const triggerCartLogic = () => {
    const existingCartId =
        isBrowser() && localStorage?.getItem("guestCartId");

      if (!existingCartId) {
        const tempCartId = `temp-${uuidv4()}`;
        isBrowser() && localStorage?.setItem("guestCartId", tempCartId);
      } else if (!existingCartId.startsWith("temp-")) {
        // Fetch existing guest cart
        fetchGuestCart(
          {
            cartId: existingCartId,
            apolloClient,
          },
          dispatch,
          routerPathName
        ).catch((error) => {
          console.error("Error fetching guest cart:", error);
        });
      }
  }
  useEffect(() => {
    const handlePageShow = () => {
      const returningFromCart = localStorage.getItem("returningFromCart");
  
      if (returningFromCart === "true") {
        localStorage.removeItem("returningFromCart");
        console.log("returningFromCart", returningFromCart);
        triggerCartLogic();
      }
    };
  
    window.addEventListener("pageshow", handlePageShow);
  
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [triggerCartLogic]);
  useEffect(() => {
    if (isSignedIn === SignedinState.SIGNEDOUT) {
      triggerCartLogic();
    }
  }, [isSignedIn, routerPathName]);

  manageCart({ dispatch });

  useEffect(() => {
    if (serverCartErrorMessage) {
      setTimeout(() => {
        dispatch(setServerCartErrorMessage(""));
      }, 10000);
    }
  }, [serverCartErrorMessage]);

  const isCartPopoverOpen = !!serverCartErrorMessage.length;

  return (
    <>
      {isCartPopoverOpen && (
        <Popover
          className={ua?.isDesktop ? styles.outOfStockPopover : ""}
          open={!!serverCartErrorMessage.length}
          label="Cart popover"
          placement={ua?.isDesktop ? "bottomRight" : "bottom"}
        >
          <OutOfStockCard
            leadingImage={`${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_oos.svg`}
            title="Dear Customer!"
            subTitle={serverCartErrorMessage}
            ctaText="Ok, Got It"
            ctaButtonColor="secondaryPharma"
            ctaClick={() => dispatch(setServerCartErrorMessage(""))}
            onClick={() => dispatch(setServerCartErrorMessage(""))}
          />
        </Popover>
      )}
    </>
  );
};

export default CartManager;
